<template>
<!-- ログイン 入力フォーム -->
<div id="login">
    <div id="content">
        <div class="inner center">
			<h2>パスワード再発行</h2>
			<div class="login_area"><!-- 入力 -->
				<p><fa icon="check-circle" class="fas fa-check-circle fa-fw" />新しいパスワードをメールで送信しました。</p>
				<div class="hosoku">
				<p class="hosoku_title"><fa icon="caret-right" class="fas fa-caret-right fa-fw"/>ご確認ください</p>
				<p class="hosoku_text">以下の場合は青森市ボランティアセンターまでお問い合わせください。</p>
				<p class="hosoku_text listicon">メールアドレスを登録していない</p>
				<p class="hosoku_text listicon">再発行完了メールが届いていない</p>
				<p class="hosoku_text">お問合せ先：017-723-1340</p>
				</div>
				<div class="login_button"><!-- ボタン -->
					<router-link to="/login">
						<button class="btn_login">ログイン画面へ</button>
					</router-link>
				</div>
			</div>
        </div>
    </div>
</div>
</template>

<script>
// import {computed} from 'vue';
import { inject } from 'vue';
export default {
    name: 'Password',  //コンポーネントに名前をつける
    data() {
        return {
			error_name: "",
        };
    },
	setup () {
		const { login, isLogin } = inject('loginstate');
		return {
			login,
			isLogin,
		}
	},
	methods: {
		gotoTop() {
			if (this.login.user_type) {
				this.error_name = ""
			} else {
				setTimeout(() => {
					this.error_name = "ログイン情報が正しくありません。";
				},500);
			}
		},
	}
};
</script>

<style scoped>
.login_area {
	width: 50%;
	margin: 0 auto;
}
@media screen and (max-width: 767px) {
	.login_area {
		width: 100%;
	}
}
.form_area dt {
    float:left;
    width: 100px;
    /* margin: 0 0 10px; */
}
.form_area dd {
    margin: 0 0 10px;
}

.form_area label.form_label {
    font-weight: bold;
    font-size: 1rem;
}
.form_area label.label_sub {
    font-weight: normal;
    font-size: 1rem;
}
.form_area input {
    font-size: 1rem;
}
</style>